/**
 * Helper function to check if Indian stock market is open
 * Market hours: 9:15 AM - 3:30 PM IST, Monday to Friday
 * @returns {boolean} true if market is open, false otherwise
 */
export const isMarketOpen = () => {
  const now = new Date();
  // Convert to IST (UTC+5:30)
  const istOffset = 5.5 * 60; // IST is UTC+5:30 in minutes
  const utcMinutes = now.getUTCHours() * 60 + now.getUTCMinutes();
  const istMinutes = utcMinutes + istOffset;
  const istHours = Math.floor(istMinutes / 60) % 24;
  const istMins = istMinutes % 60;
  
  // Get day in IST
  const istDate = new Date(now.getTime() + istOffset * 60 * 1000);
  const dayOfWeek = istDate.getUTCDay(); // 0 = Sunday, 6 = Saturday
  
  // Check if weekend
  if (dayOfWeek === 0 || dayOfWeek === 6) return false;
  
  // Market hours: 9:15 AM to 3:30 PM IST
  const marketOpen = 9 * 60 + 15; // 9:15 AM = 555 minutes
  const marketClose = 15 * 60 + 30; // 3:30 PM = 930 minutes
  const currentTime = istHours * 60 + istMins;
  
  return currentTime >= marketOpen && currentTime <= marketClose;
};

/**
 * Get market status message
 * @returns {string} Status message
 */
export const getMarketStatus = () => {
  if (isMarketOpen()) {
    return 'Market Open';
  }
  
  const now = new Date();
  const istOffset = 5.5 * 60;
  const istDate = new Date(now.getTime() + istOffset * 60 * 1000);
  const dayOfWeek = istDate.getUTCDay();
  
  return 'Market Closed';
};

export default isMarketOpen;
